import { FC, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { styles } from "../stylesForgotPassword";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useForgotPasswordMutation, useValidateOtpMutation } from "@/store/api/authApi";
import OtpForm from "@/pages/Confirmation/OtpForm";

interface IVerifyEmailProps {
  setForgotPasswordStep: (step: number) => void;
  setOtpCode: (value: any) => void;
}

const VerifyEmail: FC<IVerifyEmailProps> = ({ setForgotPasswordStep, setOtpCode }) => {
  const [validateOtp] = useValidateOtpMutation();
  const [forgotPassword] = useForgotPasswordMutation();

  const inputsRef = useRef<HTMLInputElement[]>([]);
  const { email } = useAppSelector((state) => state.authForgotPassword);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  return (
    <Box sx={styles.wrapper}>
      <OtpForm
        email={email!}
        length={6}
        onSubmit={async (otpCode) => {
          try {
            await validateOtp({ otp: otpCode }).unwrap();
            setOtpCode(otpCode);
            setForgotPasswordStep(2);
          } catch (err) {
            console.error("OTP validation error", err);
          }
        }}
        onResend={async () => {
          try {
            await forgotPassword({ email }).unwrap();
          } catch (err) {
            console.error("Resend OTP error", err);
          }
        }}
        onHeaderClick={() => setForgotPasswordStep(0)}
      />
    </Box>
  );
};

export default VerifyEmail;
